//#region Libraries
import { Link } from 'react-router-dom';
import styled from "styled-components";
//#endregion

export const Container = styled(Link)`
    text-decoration: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin: 0;
    gap: 10px;
    border-radius: 8px;
    width: 260px;
    height: 90px;
    background-color: var(--light-1);
    & svg, & path {
        fill: var(--purple-2);
    }
    &, & *:not(svg) {
        transition: 0.35s;
    }
    &:hover {
        background-color: var(--purple-2);
        & * {
            color: var(--light-1) !important;
        }
        & svg, & path {
            fill: var(--light-1);
        }
    }
    &.secondary {
        border: 1px solid var(--purple-2);
        justify-content: center;
        align-items: center;
        padding: 20px 10px;
        width: 220px;
        height: 100px;
    }
    @media (max-width: 560px) {
        width: 58vw;
    }
`;
export const Title = styled.div` 
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    width: 180px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: var(--purple-6);
    margin: 0;
    &.secondary {
        width: max-content;
    }
`;

 